import Cookies from "js-cookie";

export default class CookieNotice {
  constructor(app) {
    this.app = app;
    this.cookieNotice = document.querySelector(".js-cookie-notice");
    this.allLinks = document.querySelectorAll(".js-cookie-notice a");
    this.consentLink = document.querySelector(".js-cookie-consent");

    this.cookieName = "park2020";
    this.cookies = {
      a: true, // analytics
      m: true, // marketing
    };

    this.showCookieNotice = this.showCookieNotice.bind(this);
    this.hideCookieNotice = this.hideCookieNotice.bind(this);
    this.setCookies = this.setCookies.bind(this);

    this.events();
    this.init();
  }

  init() {
    if (this.cookieNotice) {
      if (Cookies.get(`${this.cookieName}`)) return;
      this.cookieNotice.classList.remove("--inactive");
      setTimeout(this.showCookieNotice, 1500);
    }
  }

  events() {
    this.allLinks.forEach(link => {
      link.addEventListener("click", this.hideCookieNotice);
    });
    this.consentLink.addEventListener("click", this.setCookies);
  }

  destroy() {}

  hideCookieNotice() {
    this.cookieNotice.classList.remove("--active");
    setTimeout(() => {
      this.cookieNotice.classList.add("--inactive");
    }, 1000);
  }

  showCookieNotice() {
    this.cookieNotice.classList.add("--active");
  }

  setCookies() {
    Cookies.set(`${this.cookieName}`, true, {
      expires: 365,
      secure: false,
    });

    Object.keys(this.cookies).forEach(key => {
      if (Cookies.get(`${this.cookieName}-${key}`)) return;
      const value = !!this.cookies[key];
      Cookies.set(`${this.cookieName}-${key}`, value, {
        expires: 365,
        secure: false,
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/cookieNotice.js